import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import {
  GenericModalResults,
  GenericModalSources,
  GenericModalTrackingConfig,
} from '@legacy/common-ui-shared-interfaces';
import { InnogyComponentRendering } from '@core/jss-models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { NgClass } from '@angular/common';
import { ModalComponent, ModalBodyDirective } from '@legacy/common-ui-shared';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import {
  TrackImpressionDirective,
  TrackLinkDirective,
} from '@analytics/events';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { TextInterpolationPipe } from '@core/jss-utils';

import { closeGenericModal } from './+state/generic-modal.actions';

@Component({
  selector: 'wl-generic-modal',
  templateUrl: './generic-modal.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    ModalComponent,
    AutomationIdDirective,
    TrackImpressionDirective,
    ModalBodyDirective,
    RichTextWrapperComponent,
    TrackLinkDirective,
    NgClass,
    TextInterpolationPipe,
  ],
})
export class GenericModalComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() source: GenericModalSources = GenericModalSources.GENERIC_MODAL;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() title = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() body = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() primaryButtonText = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() primaryButtonStyle = 'btn btn-primary';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() chatbotSelectorClass = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() secondaryButtonText = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() secondaryButtonStyle = 'btn btn-link';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() tracking?: GenericModalTrackingConfig;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() autoCloseTime?: number;

  additionalPayload: any;
  interpolatablePayload: { [key: string]: any } = {};
  impressionTitle = '';
  impressionSecondaryText = '';

  constructor(
    readonly activeModal: NgbActiveModal,
    private readonly store$: Store
  ) {}

  ngOnInit(): void {
    // initialize tracking elements
    this.impressionTitle = this.tracking?.toolName
      ? `${this.tracking.toolName} ${this.title}`
      : this.title;
    this.impressionSecondaryText = this.tracking?.toolName
      ? `${this.tracking.toolName} ${this.secondaryButtonText}`
      : this.secondaryButtonText;
    if (this.autoCloseTime) {
      setTimeout(() => {
        this.close();
      }, this.autoCloseTime * 1000);
    }
  }

  primary() {
    this.store$.dispatch(
      closeGenericModal({
        source: this.source,
        result: GenericModalResults.PRIMARY,
        additionalPayload: this.additionalPayload,
      })
    );
    this.activeModal.close();
  }

  close() {
    this.store$.dispatch(
      closeGenericModal({
        source: this.source,
        result: GenericModalResults.CLOSE,
        additionalPayload: this.additionalPayload,
      })
    );
    this.activeModal.close();
  }

  secondary() {
    this.store$.dispatch(
      closeGenericModal({
        source: this.source,
        result: GenericModalResults.SECONDARY,
        additionalPayload: this.additionalPayload,
      })
    );
    this.activeModal.close();
  }

  buttonClickEventType(buttonStyle?: string) {
    if (
      buttonStyle &&
      typeof buttonStyle === 'string' &&
      buttonStyle.includes('btn-link')
    ) {
      return 'link-click';
    }

    return 'button-click';
  }

  /**
   * Combines the primary button class from SC with an optional CSS selector class for the chatbot
   */
  get primaryButtonClasses() {
    return `${this.primaryButtonStyle} ${this.chatbotSelectorClass}`;
  }
}
